import { useState } from "react";
import { Crown } from "lucide-react";
import { toast } from "sonner";
import { joinProgram, useAmbassadorSnapshot } from "@/lib/ambassadors/ambassadorEngine";

export function JoinAmbassadorCard() {
  const { me } = useAmbassadorSnapshot();
  const [handle, setHandle] = useState(me.handle);
  const [nation, setNation] = useState(me.nation);

  if (me.isAmbassador) {
    return (
      <section className="rounded-2xl border border-primary/60 bg-primary/5 p-3">
        <div className="flex items-center gap-2 text-sm font-black">
          <Crown className="h-4 w-4 text-primary" /> Eres Ambassador · {me.nation}
        </div>
        <div className="mt-1 text-[11px] text-muted-foreground">
          Tu código: <span className="font-mono font-bold">{me.referralCode}</span>
        </div>
      </section>
    );
  }

  return (
    <section className="rounded-2xl border border-border/60 bg-background/60 p-3">
      <h3 className="flex items-center gap-1.5 text-sm font-black uppercase tracking-wider">
        <Crown className="h-3.5 w-3.5 text-primary" /> Conviértete en Ambassador
      </h3>
      <p className="mt-1 text-[11px] text-muted-foreground">
        Lidera tu nación. Gana glow, badges y showcase placement.
      </p>
      <div className="mt-2 grid gap-2 sm:grid-cols-2">
        <input
          className="rounded-lg border border-border/60 bg-background px-2 py-1 text-xs"
          value={handle}
          onChange={(e) => setHandle(e.target.value)}
          placeholder="@handle"
        />
        <input
          className="rounded-lg border border-border/60 bg-background px-2 py-1 text-xs"
          value={nation}
          onChange={(e) => setNation(e.target.value.toUpperCase().slice(0, 3))}
          placeholder="MEX"
        />
      </div>
      <button
        type="button"
        onClick={() => {
          joinProgram({ handle: handle.trim() || "@you", nation: nation.trim() || "MEX" });
          toast.success("Bienvenido al programa ✨");
        }}
        className="mt-2 w-full rounded-full bg-primary px-3 py-1.5 text-xs font-black text-primary-foreground active:scale-95"
      >
        Unirme al programa
      </button>
    </section>
  );
}
